export const environment = {
  env: 'sbx',
  local: false,
  sbx: true,
  uat: false,
  production: false,
  domainUrl: 'bestegg.com',
  cswUrl: 'https://customers.sbx.bestegg.com',
  cswUrlVersion: 'https://customers.sbx.bestegg.com/version',
  authUrl: 'https://auth.sbx.bestegg.com',
  funnelLoginUrl: 'https://sbx.bestegg.com/apply/login?legacy_login=true',
  resumeApplicationUrl: 'https://www.uat.bestegg.com/apply/login',
  samlUrl: 'https://idp.sbx.bestegg.com/v2/saml2',
  amplify_config: {
    region: 'us-east-1',
    // using sbx-bestegg-userpool to run sandbox test
    userPoolId: 'us-east-1_ecqUGekKq',
    userPoolWebClientId: '1q6nqvt634f9m25t9abvvl28v6',
  },
  appVersion: require('../../package.json').version,
  vantageScore: 'https://customer-gateway.sbx.bestegg.com/vantage-score',
  customerGateway: 'https://customer-gateway.sbx.bestegg.com',
  customerAttributes: 'https://customer-gateway.sbx.bestegg.com/customer-attributes',
  cardSsoUrl: 'https://uat.tsysweb.com/sso/login?product=BESTEGG',
  cardUrl: 'https://card.sbx.bestegg.com',
  cardSsoLogUrl: 'https://customer-gateway.sbx.bestegg.com/log-message',
  mainDomain: '.bestegg.com',
  apiBaseUrl: 'https://www.uat.bestegg.com/api',
  befhDomain: 'https://twig.sbx.bestegg.com/financial-health',
  recaptchaSiteKey: '6Ld_URolAAAAACl1xKUjO__fGy9efAWocWQqb3hM',
  localDomainOverride: null,
  referAFriendUrl: 'https://cis.sbx.bestegg.com/customer-incentive-service/api/v1/refer-a-friend',
  loanAuthenticatedUrl: 'https://www.uat.bestegg.com/personal-loans-authenticated',
  creditCardKcfUrl: 'https://card.uat.bestegg.com/apply/application',
  cswCustomerService: 'https://customers.sbx.bestegg.com/csw-customer-service/api/v1/customers',
  cswEpayService: 'https://customers.sbx.bestegg.com/csw-epay-service/api/v2/customers',
  paperlessStatusUpdateEndpoint: 'https://customers.sbx.bestegg.com//paperless-enrollment-update',
  dataDogConfig: {
    applicationId: null,
    clientToken: null,
    site: null,
    service: null,
    env: 'sbx',
    sessionSampleRate: null,
    sessionReplaySampleRate: null,
    defaultPrivacyLevel: null,
  },
  dataDogLogsConfig: {
    clientToken: null,
    site: null,
    service: null,
    env: 'sbx',
    version: null,
    sessionSampleRate: null,
    forwardErrorsToLogs: false,
    forwardConsoleLogs: [],
  },
  segmentWriteKey: 'sGTsnKeOkV3tVVbUy7FCCIxk9EW2h4PD',
  oneTrustDomainScript: '019d25ed-51d1-74f3-a488-a56367622706-test',
};
